import { z } from 'zod';

import { clientSchema } from 'entities/Client';
import { employeeSchema } from 'entities/Employee';
import { idWithNameSchema } from 'entities/IdWithName';
import { meetingSchemaBase } from 'entities/Meeting/MeetingSchemaBase';
import { subAgentSchema } from 'entities/SubAgent';

import { leadStatus } from './LeadStatus';

export const leadSchema = z
  .object({
    id: z.number(),
    status: leadStatus,
    client: clientSchema,
    user: employeeSchema.nullable(),
    project: idWithNameSchema.nullable(),
    place_type: idWithNameSchema.nullable(),
    comment: z.string().nullable(),
    fixed_until: z.string().pipe(z.coerce.date()).nullable(),
    created_at: z.string().pipe(z.coerce.date()),
    actual_meeting: z.lazy(() => meetingSchemaBase.nullable().optional()),
    sub_agent: subAgentSchema.nullable().optional(),
  })
  .transform((raw) => {
    return {
      id: raw.id,
      status: raw.status,
      client: raw.client,
      user: raw.user,
      project: raw.project,
      placeType: raw.place_type,
      comment: raw.comment,
      fixedUntil: raw.fixed_until,
      createdAt: raw.created_at,
      actualMeeting: raw.actual_meeting,
      subAgent: raw.sub_agent,
    };
  });

export type LeadEntityApi = z.input<typeof leadSchema>;

export type LeadEntity = z.infer<typeof leadSchema>;
